export default __webpack_public_path__ + "static/media/SampleLoad.70aaa5d6.csv";